// extracted by mini-css-extract-plugin
module.exports = {"header":"common-CategoryPage__header--1Aeca","title":"common-CategoryPage__title--13IMv","shareBtn":"common-CategoryPage__shareBtn--3BGdQ"};